const bulkOperation = {
  methods: {
    executeBulkOperation: function (promises) {
      this.beforeBulk()
      Promise.all(promises
        .map(p => p.catch(e => this.handleBulkError(e))))
        .then(response => {
          let successfulResponses = response.filter(item => item !== undefined)
          if (successfulResponses.length > 0) {
            this.handleBulkSuccess(successfulResponses)
          }
        })
        .finally(() => {
          this.afterBulk()
        })
    },

    beforeBulk: function () {
      console.error('Implement the beforeBulk method if you  want to trigger loading states, disable buttons etc before the operation')
    },

    handleBulkError: function (error) {
      console.error('Implement handleBulkError to handle the error from each promise' + error)
    },

    handleBulkSuccess: function (responses) {
      console.error('Implement handleBulkSuccess if you want to handle the response from all the promises, update lists, create success message etc')
    },

    afterBulk: function () {
      console.error('Implement the afterBulk method if you  want to trigger some behaviour after all the operations are finished')
    }

  }
}

export default bulkOperation
